<script setup lang="ts">
import BaseButton from "@/core/components/base/BaseButton.vue";
import {pluralize} from "@/core/filters/Pluralize";

defineProps<{
    todayConsumers?: number;
    laboratoryName: string;
    primaryColor?: string;
    secondaryColor?: string;
    laboratoryId: string;
}>();
</script>

<template>
  <div class="bg-white rounded-md shadow-2xl flex flex-col">
    <div class="flex items-baseline px-4 pt-4 justify-between">
      <h1 class="font-content-bold text-black">
        Animez vos patients
      </h1>
      <p
        class="font-bold underline"
        :style="{
          color: primaryColor
        }"
      >
        {{ todayConsumers ?? 0 }} {{ pluralize('client', todayConsumers ?? 0) }} aujourd'hui
      </p>
    </div>
    <div class="flex flex-col gap-4 h-full">
      <p class="px-4">
        Découvrez comment {{ laboratoryName }} vous aide à animer vos patients automatiquement, et au bon moment !
      </p>
      <div
        class="h-full flex justify-center items-center min-h-24 relative w-full overflow-hidden"
      >
        <img src="@/assets/images/flying_paperplane_1.svg" alt="flying paper" class="left-0 absolute h-14 select-none">
        <img src="@/assets/images/flying_paperplane_2.svg" alt="flying paper" class="right-0 absolute h-18 select-none">
        <BaseButton
          append-icon="mdi-send"
          :color="primaryColor"
          :style="[
            'color: ' + (secondaryColor ?? '')
          ]"
          :to="{
            name: 'laboratory.animation',
            params: {laboratoryId}
          }"
        >
          Découvrir les animations SMS
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
